import { createElement } from "react";
import { clsx } from "clsx";

import "./Heading.css";

import type { ReactNode, CSSProperties } from "react";

export interface HeadingProps {
  children: ReactNode;
  className?: string;
  displayLevel?: "1" | "2" | "3" | "4" | "5" | "6";
  level?: "1" | "2" | "3" | "4" | "5" | "6";
  style?: CSSProperties;
}

export function Heading({
  children,
  className,
  displayLevel,
  level = "1",
  style,
}: HeadingProps) {
  const tagName = `h${level}`;

  return createElement(
    tagName,
    {
      className: clsx("Heading", className),
      "data-level": displayLevel ?? level,
      style,
    },
    children,
  );
}
